window.addEventListener('load', (e) => {

  let tcaBtns = document.querySelectorAll('.two-col-accordion .accordion-button');
  let tcaPanels = document.querySelectorAll('.two-col-accordion .accordion-panel');
  
  
  for (let i = 0; i < tcaBtns.length; i++) {
    let element = tcaBtns[i];

    if(element.classList.contains('open')) {
      element.nextElementSibling.style.maxHeight = element.nextElementSibling.scrollHeight + 'px';
    }
    
    element.addEventListener('click', () => {

      if(element.classList.contains('open')) {
        element.classList.toggle('open');
        element.nextElementSibling.style.maxHeight = 0;
      } else {
        [...tcaBtns].forEach(btn => {
          btn.classList.remove('open');
        });
    
        [...tcaPanels].forEach(panel => {
          panel.style.maxHeight = 0;
        });

        element.classList.toggle('open');
        element.nextElementSibling.style.maxHeight = element.nextElementSibling.scrollHeight + 'px';
      }
      
      
    });
  }
});